// src/components/EmailVerification.js
import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import './EmailVerification.css';

const EmailVerification = ({ email, password }) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const navigate = useNavigate();
      const [modalVisible, setModalVisible] = useState(false);
      const [modalMessage, setModalMessage] = useState('');


  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input
    if (value && index < 5) inputRefs.current[index + 1].focus();
  };

  const handlePaste = (e) => {
  e.preventDefault();
  const paste = e.clipboardData.getData('text').trim();
  if (/^\d{6}$/.test(paste)) {
    const newOtp = paste.split('');
    setOtp(newOtp);
    // Focus the last input after paste
    inputRefs.current[5]?.focus();
  }
};


  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  const code = otp.join("");

  if (code.length === 6) {
    try {
      const response = await fetch('https://pst-file-uploader.finkraftai.com/api/verify-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, otp: code }),
      });

      const data = await response.json();

      if (response.ok) {
        // Save email to localStorage
        localStorage.setItem('userEmail', email);
        setModalMessage('OTP verified successfully!');
       

        navigate('/');
      } else {
        setModalMessage(data.message || 'OTP verification failed.');
         setModalVisible(true);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      alert('Something went wrong.');
    }
  }
};


const handleResend = async (e) => {
  e.preventDefault(); // Prevent anchor default behavior

  try {
    const response = await fetch('https://pst-file-uploader.finkraftai.com/api/send-otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      setModalMessage(data.message || 'OTP has been resent to your email.');
      setModalVisible(true);
      
    } else {
      setModalMessage(data.message || 'Failed to resend OTP.');
      setModalVisible(true);
    }
  } catch (error) {
    console.error('Error resending OTP:', error);
    alert('An error occurred while resending the OTP.');
  }
};


  return (
    <>
    {modalVisible && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>Login Info</h3>
            <p style={styles.modalText}>{modalMessage}</p>
            <button onClick={() => setModalVisible(false)} style={styles.modalButton}>Close</button>
          </div>
        </div>
      )}
    <div className="signup-form-container">
      <h2>Verify Your Email</h2>
      <p>Please enter the 6-digit verification code we’ve sent at your registered email address.</p>

      <form onSubmit={handleSubmit} className="otp-form">
        <div className="otp-inputs">
          {otp.map((digit, i) => (
            <input
            key={i}
            type="text"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(e, i)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            onPaste={i === 0 ? handlePaste : undefined}
            ref={(el) => (inputRefs.current[i] = el)}
          />

          ))}
        </div>

        <div className="otp-links">
          Didn't get it?{" "}
          <a href="#" onClick={handleResend}>Resend Code</a> or <Link to='/signup'>Change Email Address</Link>
        </div>

        <button type="submit" className="submit-btn">Continue</button>

        <p className="signin-link">
          Already have an account? <a href="#">Sign in</a>
        </p>
      </form>
    </div>
    </>
  );
};


const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    padding: '2rem',
    maxWidth: '400px',
    margin: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  input: {
    padding: '0.75rem',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
  },
  button: {
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999, // ADD this: high z-index to cover everything
  },
  modal: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '10px',
    width: '300px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    zIndex: 10000, // ADD this: modal should be above overlay (optional)
  },
  modalTitle: {
    marginBottom: '1rem',
  },
  modalText: {
    marginBottom: '1.5rem',
  },
  modalButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  }
};

export default EmailVerification;
